//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import moment from 'moment';

export default {
    data: function data() {
        return {
            applicant: this.inapplicant,
            unit: this.inunit,
            units: this.inunits,
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            move_in_date: this.applicant && this.applicant.person && this.applicant.person.move_in_date ? applicant.person.move_in_date : moment().add(1, 'months').format('MM-DD-YYYY'),
            application_fee: 0,
            security_deposit: 0,
            pets_number: 0,
            pet_fee: 0,
            pet_rent: 0,
            pet_additional_rent: 0,
            set_prorated_rent: null,
            selectedInsurance: '',
            insurance_amount: {},
            property: {},
            propertySettings: {},
            rentalInsurances: []
        };
    },

    methods: {
        getLeaseSettings: function getLeaseSettings() {
            var self = this;
            window.axios.get('/prototype/property/lease-settings').then(function (response) {
                if (response.data) {
                    self.propertySettings = response.data;
                    self.pet_additional_rent = response.data.pet_additional_rent;
                }
            });
        },
        getRentalInsurance: function getRentalInsurance() {
            var self = this;
            window.axios.get('/prototype/property/rental-insurance').then(function (response) {
                if (response.data) {
                    self.rentalInsurances = response.data;
                    self.insurance_amount = response.data[0];
                }
            });
        },
        updatePrices: function updatePrices(val) {
            console.log('val', val);
            this.unit = val;
        }
    },
    watch: {
        pets_number: function pets_number(val) {
            this.pet_rent = val * this.pet_fee;
        },
        applicant: function applicant(newVal, oldVal) {
            var self = this;
            this.move_in_date = newVal && newVal.person && newVal.person.move_in_date ? newVal.person.move_in_date : moment().add(1, 'months').format('MM-DD-YYYY');

            if (newVal && newVal.leases && newVal.leases.length) {
                var l = newVal.leases[newVal.leases.length - 1];
                self.set_prorated_rent = l.prorated_rent;
                self.security_deposit = l.security_deposit;
                self.pet_fee = l.pet_additional_rent;
            }
        }
    },
    computed: {
        total: function total() {
            var t = this.application_fee + this.security_deposit + this.prorated_rent + this.pet_rent;
            if (this.insurance_amount && this.insurance_amount.amount) {
                t += parseFloat(this.insurance_amount.amount);
            }
            return t.toFixed(2);
        },
        rent: function rent() {
            if (this.unit) {
                if (this.unit.rent_amount) return this.unit.rent_amount.toFixed(2);
                if (this.unit.rent) return this.unit.rent.toFixed(2);
                if (this.unit.price) return this.unit.price.toFixed(2);
            }
            return 0;
        },
        prorated_rent: function prorated_rent() {
            if (this.set_prorated_rent) return this.set_prorated_rent;

            var unit = this.unit,
                applicant = this.applicant,
                move_in_date = this.move_in_date;

            if (!unit || !applicant || !move_in_date) return 0;

            var price = unit.price || unit.rent_amount || unit.rent; //we have inconsistencies in the naming

            move_in_date = moment(move_in_date, 'MM/DD/YYYY');

            if (move_in_date.isBefore(moment().format('MM/DD/YYYY'))) return 0;

            var endOfMonth = move_in_date.clone();
            endOfMonth = moment(endOfMonth.add(1, 'months').date(1).subtract(1, 'days').format('YYYY-MM-DD'));

            var days = endOfMonth.diff(move_in_date, 'days') + 1; //add date of actual move-in

            var daysInMonth = move_in_date.daysInMonth();
            return price / daysInMonth * days;
        }
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        Event.$on('show-move-in-calculator', function (applicant, unit, units) {
            _this.getLeaseSettings();
            _this.getRentalInsurance();
            self.applicant = applicant;
            self.unit = unit;
            self.units = units;
            Event.$emit('show-small-modal', false, false, 'move-in-calculator');
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('show-move-in-calculator');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/MoveInCalculator.vue
// module id = 31Y+
// module chunks = 0 1